export const users = 'users'
export const teachers = 'teachers'